module.exports = __webpack_public_path__ + "img/fenxiang.65f747d4.png";